"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VisibilityRow = exports.VisibilityCheckboxList = exports.CenteredSpinner = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _BasicCallout = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/BasicCallout"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _Spinner = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Spinner"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Checkbox = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Checkbox"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _objects = require("../../../../utils/objects");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LinkIcon = function LinkIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.003 3.544a5.27 5.27 0 1 1 7.453 7.453l-3.45 3.45a5.271 5.271 0 0 1-6.885.495 1 1 0 1 1 1.2-1.6 3.271 3.271 0 0 0 4.27-.309l3.451-3.45a3.27 3.27 0 0 0-4.625-4.625l-.431.431a1 1 0 1 1-1.414-1.414l.431-.431zm-.324 7.115a3.271 3.271 0 0 0-4.27.307l-3.451 3.451a3.27 3.27 0 1 0 4.625 4.625l.431-.431a1 1 0 0 1 1.414 1.414l-.431.431a5.27 5.27 0 0 1-7.453-7.453l3.45-3.45a5.271 5.271 0 0 1 6.885-.494 1 1 0 1 1-1.2 1.6z"
  }));
};
LinkIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "body": "ShareToPublicPortalPanel__body__268Vt",
  "no-bullet": "ShareToPublicPortalPanel__no-bullet__1B7u-",
  "noBullet": "ShareToPublicPortalPanel__no-bullet__1B7u-",
  "version-row": "ShareToPublicPortalPanel__version-row__3FB3p",
  "versionRow": "ShareToPublicPortalPanel__version-row__3FB3p",
  "centered": "ShareToPublicPortalPanel__centered__4UhaV",
  "name": "ShareToPublicPortalPanel__name__3YSae",
  "visibility": "ShareToPublicPortalPanel__visibility__88AUx",
  "bold": "ShareToPublicPortalPanel__bold__3ulVx",
  "disabled-callout": "ShareToPublicPortalPanel__disabled-callout__3hWpQ",
  "disabledCallout": "ShareToPublicPortalPanel__disabled-callout__3hWpQ",
  "spinner": "ShareToPublicPortalPanel__spinner__2W9RP",
  "footer": "ShareToPublicPortalPanel__footer__B9aTT",
  "link-container": "ShareToPublicPortalPanel__link-container__-qDFm",
  "linkContainer": "ShareToPublicPortalPanel__link-container__-qDFm",
  "link-anchor": "ShareToPublicPortalPanel__link-anchor__371Vj",
  "linkAnchor": "ShareToPublicPortalPanel__link-anchor__371Vj",
  "link-icon": "ShareToPublicPortalPanel__link-icon__2a8jM",
  "linkIcon": "ShareToPublicPortalPanel__link-icon__2a8jM"
}; 
require('./ShareToPublicPortalPanel.css');
var tooltipTheme = {
  "tooltip-wrap": "TooltipTheme__tooltip-wrap__1hf_3",
  "tooltipWrap": "TooltipTheme__tooltip-wrap__1hf_3",
  "tooltip-position-right": "TooltipTheme__tooltip-position-right__1a4i9",
  "tooltipPositionRight": "TooltipTheme__tooltip-position-right__1a4i9"
}; 
require('./TooltipTheme.css');
var buildForm = function buildForm(versionGroups) {
  return versionGroups.reduce(function (accum, _ref) {
    var versionGroup = _ref.versionGroup,
      isPublic = _ref.isPublic;
    return _objectSpread(_objectSpread({}, accum), {}, (0, _defineProperty2.default)({}, versionGroup, isPublic));
  }, {});
};
var VisibilityRow = exports.VisibilityRow = function VisibilityRow(_ref2) {
  var versionGroup = _ref2.versionGroup,
    _ref2$isReleased = _ref2.isReleased,
    isReleased = _ref2$isReleased === void 0 ? true : _ref2$isReleased,
    form = _ref2.form,
    _onChange = _ref2.onChange,
    index = _ref2.index;
  var defaultCheckbox = /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    key: index,
    value: form[versionGroup],
    name: versionGroup,
    className: styles.centered,
    disabled: !isReleased,
    onChange: function onChange(event) {
      return _onChange(versionGroup, event.value);
    }
  });
  var checkboxWrappedWithTooltip = /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    testId: "api-summary-disabled",
    theme: tooltipTheme,
    content: "Cannot be made public since it only contains snapshots",
    position: "right"
  }, defaultCheckbox);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isReleased ? defaultCheckbox : checkboxWrappedWithTooltip, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: versionGroup,
    className: styles.name,
    "data-test-id": "".concat(versionGroup, "-label")
  }, versionGroup), /*#__PURE__*/_react.default.createElement("em", {
    className: (0, _classnames.default)(styles.visibility, (0, _defineProperty2.default)({}, styles.bold, form[versionGroup])),
    "data-test-id": "".concat(versionGroup, "-visibility")
  }, form[versionGroup] ? 'Public' : 'Private'));
};
var VisibilityCheckboxList = exports.VisibilityCheckboxList = function VisibilityCheckboxList(_ref3) {
  var versionGroups = _ref3.versionGroups,
    form = _ref3.form,
    onChange = _ref3.onChange;
  return /*#__PURE__*/_react.default.createElement("fieldset", {
    "aria-label": "List of asset major versions to publish on the public portal"
  }, /*#__PURE__*/_react.default.createElement("legend", {
    className: "visually-hidden"
  }, "Versions"), /*#__PURE__*/_react.default.createElement("ul", {
    className: styles.noBullet
  }, versionGroups.map(function (_ref4, index) {
    var versionGroup = _ref4.versionGroup,
      isReleased = _ref4.isReleased;
    return /*#__PURE__*/_react.default.createElement("li", {
      className: styles.versionRow,
      key: versionGroup
    }, /*#__PURE__*/_react.default.createElement(VisibilityRow, {
      versionGroup: versionGroup,
      isReleased: isReleased,
      form: form,
      onChange: onChange,
      index: index
    }));
  })));
};
var CenteredSpinner = exports.CenteredSpinner = function CenteredSpinner() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.spinner,
    "data-test-id": "public-share-modal-spinner"
  }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    size: "l"
  }));
};
var ShareToPublicPortalPanel = exports.default = /*#__PURE__*/function (_React$Component) {
  function ShareToPublicPortalPanel(props, defaultProps) {
    var _this;
    (0, _classCallCheck2.default)(this, ShareToPublicPortalPanel);
    _this = _callSuper(this, ShareToPublicPortalPanel, [props, defaultProps]);
    (0, _defineProperty2.default)(_this, "updateIsDirty", function () {
      var form = _this.state.form;
      var _this$props = _this.props,
        versionGroups = _this$props.versionGroups,
        onUpdate = _this$props.onUpdate;
      var publicVersionGroups = versionGroups.map(function (_ref5) {
        var isPublic = _ref5.isPublic;
        return isPublic;
      });
      var selectedVersions = Object.keys(form).map(function (versionGroup) {
        return form[versionGroup];
      });
      var isDirty = !(0, _objects.shallowEquals)(selectedVersions, publicVersionGroups);
      _this.setState({
        isDirty: isDirty
      }, function () {
        return onUpdate(isDirty);
      });
    });
    (0, _defineProperty2.default)(_this, "handleSubmit", function (event) {
      event.preventDefault();
      var form = _this.state.form;
      var _this$props2 = _this.props,
        onUpdateVisibility = _this$props2.onUpdateVisibility,
        versionGroups = _this$props2.versionGroups;
      var updatedVersionGroups = Object.keys(form).reduce(function (accum, versionGroup) {
        var oldVersionGroup = versionGroups.find(function (versionGroupItem) {
          return versionGroupItem.versionGroup === versionGroup;
        });
        accum.push(_objectSpread(_objectSpread({}, oldVersionGroup), {}, {
          isPublic: form[versionGroup]
        }));
        return accum;
      }, []);
      onUpdateVisibility({
        currentVersionGroups: versionGroups,
        updatedVersionGroups: updatedVersionGroups
      });
    });
    (0, _defineProperty2.default)(_this, "handleDismiss", function (event) {
      event.preventDefault();
      var onClose = _this.props.onClose;
      onClose();
    });
    (0, _defineProperty2.default)(_this, "handleChange", function (versionGroup, value) {
      var form = _this.state.form;
      _this.updateForm(_objectSpread(_objectSpread({}, form), {}, (0, _defineProperty2.default)({}, versionGroup, value)));
    });
    (0, _defineProperty2.default)(_this, "getModalBody", function () {
      var _this$props3 = _this.props,
        asset = _this$props3.asset,
        config = _this$props3.config,
        isLoading = _this$props3.isLoading,
        versionGroups = _this$props3.versionGroups,
        isPublicPortalEnabled = _this$props3.isPublicPortalEnabled,
        InformationCallout = _this$props3.InformationCallout,
        CustomCallout = _this$props3.CustomCallout;
      var form = _this.state.form;
      if (isPublicPortalEnabled) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(InformationCallout, {
          asset: asset
        }), isLoading ? /*#__PURE__*/_react.default.createElement(CenteredSpinner, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(VisibilityCheckboxList, {
          versionGroups: versionGroups,
          form: form,
          onChange: _this.handleChange
        }), /*#__PURE__*/_react.default.createElement(CustomCallout, {
          asset: asset,
          visibilityByVersionGroup: form
        })));
      }
      return /*#__PURE__*/_react.default.createElement(_BasicCallout.default, {
        className: styles.disabledCallout,
        testId: "disabled-public-portal-callout",
        type: "warning",
        title: "The Public Portal for this organization has been disabled.",
        subtitle: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Enable the Public Portal to start sharing assets.", ' ', /*#__PURE__*/_react.default.createElement("a", {
          href: config.docsLinks.publicPortal,
          className: styles.linkAnchor
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "visually-hidden"
        }, "Go to public portal"), "Find out how."))
      });
    });
    var _versionGroups = props.versionGroups;

    // eslint-disable-next-line react/state-in-constructor
    _this.state = {
      form: buildForm(_versionGroups),
      isDirty: false
    };
    return _this;
  }
  (0, _inherits2.default)(ShareToPublicPortalPanel, _React$Component);
  return (0, _createClass2.default)(ShareToPublicPortalPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
        onComponentMounted = _this$props4.onComponentMounted,
        versionGroups = _this$props4.versionGroups;
      onComponentMounted(versionGroups);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props5 = this.props,
        reset = _this$props5.reset,
        versionGroups = _this$props5.versionGroups;
      if (prevProps.reset !== reset) {
        this.updateForm(buildForm(versionGroups));
      }
    }
  }, {
    key: "updateForm",
    value: function updateForm(form) {
      var _this2 = this;
      this.setState({
        form: form
      }, function () {
        return _this2.updateIsDirty();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        config = _this$props6.config,
        isAdding = _this$props6.isAdding,
        isPublicPortalEnabled = _this$props6.isPublicPortalEnabled;
      var isDirty = this.state.isDirty;
      return /*#__PURE__*/_react.default.createElement("form", {
        onSubmit: this.handleSubmit
      }, /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
        className: styles.body
      }, this.getModalBody()), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
        className: styles.footer
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: styles.linkContainer
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: config.docsLinks.publicPortal,
        className: styles.linkAnchor
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "visually-hidden"
      }, "Go to "), "Learn more about public portal", /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: styles.linkIcon,
        size: 15
      }, /*#__PURE__*/_react.default.createElement(LinkIcon, null)))), /*#__PURE__*/_react.default.createElement(_Button.default, {
        testId: "cancel-public-share",
        kind: "tertiary",
        type: "button",
        onClick: this.handleDismiss,
        disabled: isAdding,
        noFill: true
      }, isPublicPortalEnabled ? 'Cancel' : 'Close'), isPublicPortalEnabled ? /*#__PURE__*/_react.default.createElement(_Button.default, {
        testId: "confirm-public-share",
        kind: "primary",
        type: "submit",
        isLoading: isAdding,
        disabled: !isDirty
      }, "Save") : null));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(ShareToPublicPortalPanel, "defaultProps", {
  onUpdate: function onUpdate() {},
  onComponentMounted: function onComponentMounted() {},
  onUpdateVisibility: function onUpdateVisibility() {},
  onClose: function onClose() {},
  isPublicPortalEnabled: true,
  reset: false,
  InformationCallout: function InformationCallout() {
    return null;
  },
  CustomCallout: function CustomCallout() {
    return null;
  }
});
//# sourceMappingURL=ShareToPublicPortalPanel.js.map